<template>
  <div class="units">
    <!-- 工具栏 -->
    <el-row style="margin: 10px">
      <el-button type="primary" plain size="small" @click="openDialog(null)">添加单位</el-button>
    </el-row>
    <!-- 表格 -->
    <el-row style="margin: 10px">
      <el-col :span="24">
        <el-table :data="unitsList" style="width: 100%" border max-height="520">
          <el-table-column align="center" prop="name" label="英文名称"></el-table-column>
          <el-table-column align="center" prop="chineseName" label="中文名称"></el-table-column>
          <el-table-column align="center" prop="siName" label="公制符号"></el-table-column>
          <el-table-column align="center" prop="enName" label="英制符号"></el-table-column>
          <el-table-column fixed="right" align="center" label="操作" width="400">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openDialog(scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="deleteById(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 分页插件 -->
    <el-row>
      <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageInfo.currentPage" :page-sizes="[10, 30, 50]" :page-size="pageInfo.pageSize" layout="total, sizes, prev, pager, next" :total="pageInfo.total"></el-pagination>
    </el-row>
    <!-- 添加/修改窗口 -->
    <el-dialog width="400px" :title="dialogTitle" :visible.sync="dialogVisible">
      <el-form :inline="true" :model="formData" ref="formRef" class="form">
        <el-form-item label="英文名称" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="中文名称" prop="name">
          <el-input v-model="formData.chineseName"></el-input>
        </el-form-item>
        <el-form-item label="公制符号" prop="code">
          <el-input v-model="formData.siName"></el-input>
        </el-form-item>
        <el-form-item label="英制符号" prop="code">
          <el-input v-model="formData.enName"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      unitsList: [],
      pageInfo: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      dialogTitle: '',
      dialogVisible: false,
      formData: {
        id: null,
        name: '',
        chineseName: '',
        siName: '',
        enName: ''
      }
    }
  },
  mounted: function () {
    this.findAll(this.pageInfo.currentPage, this.pageInfo.pageSize)
  },
  methods: {
    findAll (current, size) {
      this.axios.get('/units', {
        params: {
          current: current,
          size: size
        }
      })
        .then(res => {
          this.pageInfo = {
            currentPage: res.data.current,
            pageSize: res.data.size,
            total: res.data.total
          }
          this.unitsList = res.data.records
        })
    },
    handleSizeChange (val) {
      this.findAll(1, val)
    },
    handleCurrentChange (val) {
      this.findAll(val, this.pageInfo.pageSize)
    },
    openDialog (units) {
      if (units === null) {
        this.dialogTitle = '添加单位'
      } else {
        this.formData = {
          id: units.id,
          name: units.name,
          chineseName: units.chineseName,
          siName: units.siName,
          enName: units.enName
        }
        this.dialogTitle = '编辑单位'
      }
      this.dialogVisible = true
    },
    closeDialog () {
      this.dialogTitle = ''
      this.dialogVisible = false
      this.resetForm()
    },
    submitForm () {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.saveOrUpdate()
        } else {
          return false
        }
      })
    },
    resetForm () {
      this.formData = {
        id: null,
        name: '',
        chineseName: '',
        siName: '',
        enName: ''
      }
      this.$refs.formRef.resetFields()
    },
    saveOrUpdate () {
      this.axios.post('/units', this.formData)
        .then(res => {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.closeDialog()
          this.findAll(1, 10)
        })
    },
    deleteById (id) {
      this.$confirm('是否删除该单位?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.delete(`/units/${id}`)
          .then(res => {
            this.$message({
              message: '删除成功!',
              type: 'success'
            })
            this.findAll(1, 10)
          })
      })
    }
  }
}
</script>
<style lang="less" scoped>
.pagination {
  display: flex;
  justify-content: flex-end;
}
.form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
